module.exports = __webpack_public_path__ + "static/media/mt.7893921d.svg";